<template>
  <div id="modal_1"
    class="fixed top-0 z-50 flex items-start w-full h-screen overflow-scroll bg-gray-800 bg-opacity-50 font-ww-medium">
    <div class="flex items-center justify-center w-full mx-auto max-w-8xl md:py-5 md:px-4 lg:px-16 xs-max:relative">
      <div
        class="relative flex flex-col items-center justify-center w-full max-w-screen-lg px-4 py-2 pt-5 mb-24 bg-white border-t-8 border-yellow-600 shadow-lg md:py-8 lg:px-8 xl:px-10">
        <div class="w-full modal-header ">
          <div class="mb-1 text-3xl font-medium text-center">
            Upgrade your order & unlock rewards!
          </div>

          <div class="px-8 mt-4 text-xl font-medium text-center md:px-0 md:mt-0">
            Select multiple upgrades to increase your reward level
          </div>

          <div class="relative flex w-full max-w-2xl px-2 mx-auto mt-6 mb-3 gap-x-1 md:px-0">
            <div v-for="(item, index) in rewards" :key="index" class="relative w-1/3 text-center">
              <label class="relative text-lg font-medium -top-2 lg:top-0">
                Level {{ index + 1 }}</label>
              <div class="relative grid items-center justify-center h-5 md:h-7" :class="[
                'bg-gray600',
                index == 0
                  ? 'rounded-l-full'
                  : index == rewards.length - 1
                    ? 'rounded-r-full'
                    : '',
              ]">
                <!-- Animated div for active state -->
                <div class="absolute h-full duration-500 ease-in-out transition-width" :style="{
                  width: item.active ? '100%' : '0%',
                  backgroundColor: item.active ? '#7BBD41' : '#4B5563',
                }" :class="index == 0
                  ? 'rounded-l-full'
                  : index == rewards.length - 1
                    ? 'rounded-r-full'
                    : ''
                  "></div>

                <nuxt-img v-if="item.active" style="mix-blend-mode: color-burn" class="z-30 w-4 md:w-5" width="20"
                  height="20" loading="lazy" format="webp" alt="check level"
                  src="assets/images/pngwing-1.jpg"></nuxt-img>
              </div>

              <div v-if="index == 0" class="absolute z-20 md:-right-7 -right-5 md:top-5 top-6">
                <nuxt-img class="w-9 md:w-14" width="51" height="49" src="assets/images/stars-1.svg" />
              </div>

              <div v-if="index == 1" class="absolute md:right-[-50px] -right-9 md:top-5 top-6 z-20 flex">
                <nuxt-img width="94" class="w-[65px] md:w-24" height="49" src="assets/images/stars-2.svg" />
              </div>

              <div v-if="index == 2" class="absolute z-10 top-3 md:top-0 md:-right-6 lg:-right-8 -right-4">
                <div class="relative">
                  <nuxt-img class="w-14 md:w-24" width="94" height="82" src="assets/images/stars-3.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- modal body 1 start -->
        <div class="relative w-full px-6 mt-16 md:mt-8 modal-body md:px-0">
          <div class="text-2xl text-center md:text-left md:mb-8">
            Choose your upgrades! Add as many as you want
          </div>

          <div class="grid max-w-sm grid-cols-12 m-auto mt-6 select-none gap-x-6 gap-y-8 md:max-w-full">
            <div v-for="item in upgrades" :key="item.id"
              class="relative col-span-12 cursor-pointer md:col-span-4 select-item" @click="setActive(item)">
              <div class="absolute m-auto pointer-events-none -top-2 -left-2">
                <nuxt-img width="100" height="100" loading="lazy" format="webp" :alt="item.alt"
                  :src="item.imageSrc"></nuxt-img>
                <span class="absolute inset-x-0 m-auto rotate-[-45deg] top-3.5 right-2 text-white text-sm">{{
                  item.discount }}</span>
              </div>
              <nuxt-img v-if="item.active" class="absolute top-0 right-0 pointer-events-none" width="63" height="67"
                loading="lazy" format="webp" :alt="item.alt" src="assets/images/check-green-2.png"></nuxt-img>
              <nuxt-img v-else class="absolute top-0 right-0 pointer-events-none" width="63" height="67" loading="lazy"
                format="webp" :alt="item.alt" src="assets/images/icon-plus-new.svg"></nuxt-img>
              <div :class="[
                item.active
                  ? 'bg-gray700 border-greenActive2'
                  : 'bg-white border-gray600',
                'pt-3 border-4 md:rounded-none rounded-lg',
              ]">
                <div class="grid px-10 py-2 mx-auto text-xl font-medium leading-6 text-center capitalize">
                  {{ item.title }}
                </div>
                <div class="flex justify-center mt-2 aspect-auto">
                  <nuxt-img class="pointer-events-none max-w-48 max-h-28 min-h-28" loading="lazy" format="webp"
                    :alt="item.alt" :src="item.productImage"></nuxt-img>
                </div>
                <div class="text-white py-1.5 flex justify-center items-center gap-x-2 mt-2" :class="item.active
                  ? 'bg-brown100'
                  : 'bg-gray900'
                  ">
                  <span class="line-through mt-0.5 md:text-base text-lg">+${{ item.originalPrice }}</span>
                  <span class="text-3xl font-bold md:text-2xl">+${{ item.discountedPrice }}</span>
                </div>
                <!-- <div class="tracking-[7px] text-center text-white text-2xl  font-bold font-ww-medium md:hidden"
                                  :class="item.active ? 'bg-greenActive2' : 'bg-gray600'">
                                  <span v-if="item.active">
                                      SELECTED
                                  </span>
                                  <span v-else>
                                      SELECT
                                  </span>

                              </div> -->
              </div>
            </div>
          </div>

          <div class="max-w-sm m-auto md:max-w-full">
            <div v-if="getActiveLevel() == 0" class="mt-10 mb-4 text-xl text-center sm:text-2xl md:text-left">
              <span>Select an upgrade to unlock rewards</span>
            </div>

            <div v-else-if="getActiveLevel() == 1 || getActiveLevel() == 2"
              class="mt-10 mb-4 text-xl text-center sm:text-2xl md:text-left">
              <span>Level {{ getActiveLevel() }} unlocked! Add upgrades to unlock
                more rewards</span>
            </div>

            <div class="mt-10 mb-4 text-xl text-center sm:text-2xl md:text-left" v-else>
              <span class="">Level {{ getActiveLevel() }}: unlocked! Upgrade your order
                below</span>
              <!-- Insert content or message for when neither condition is true -->
            </div>

            <div class="grid grid-cols-12 select-none gap-x-6 gap-y-6">
              <div v-for="item in rewards" :key="item.id" class="relative col-span-12 md:col-span-4 select-item">
                <div :class="item.active
                  ? 'border-greenActive2 md:rounded-none bg-[#7BBD4117]'
                  : ''
                  " class="px-2 py-1 border-4 rounded-lg">
                  <nuxt-img v-if="item.active" class="absolute top-0 right-0 pointer-events-none" width="43" height="47"
                    loading="lazy" format="webp" :alt="item.alt" src="assets/images/check-green-2.png"></nuxt-img>

                  <div v-if="!item.active"
                    class="absolute w-full z-[9] left-0 justify-center bg-gray900 top-0 bottom-0 mx-0 my-auto h-14 flex items-center px-4 gap-x-4 text-white font-semibold leading-4">
                    <nuxt-img src="assets/images/lock-icon-2.png" class="w-12 pointer-events-none md:w-14" width="30"
                      height="30" loading="lazy" format="webp"></nuxt-img>

                    <span class="text-lg leading-5 tracking-wide text-center">
                      ADD UPGRADE TO UNLOCK</span>

                    <nuxt-img src="assets/images/lock-icon-2.png" class="w-12 pointer-events-none md:w-14" width="30"
                      height="30" loading="lazy" format="webp"></nuxt-img>
                  </div>

                  <div class="mt-2 text-2xl text-center md:text-xl">
                    {{ item.title }}
                  </div>
                  <div class="grid grid-cols-12 mt-2">
                    <div class="flex items-end col-span-3">
                      <div v-for="star in item.stars">
                        <svg class="relative pointer-events-none w-7 top-2" :class="!item.active
                          ? 'blur-sm text-[rgba(0,0,0,0.25)]'
                          : ''
                          " width="51" height="49" viewBox="0 0 51 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g filter="url(#filter0_d_104_539)">
                            <path
                              d="M25.5 0L30.5516 15.5471H46.8988L33.6736 25.1558L38.7252 40.7029L25.5 31.0942L12.2748 40.7029L17.3264 25.1558L4.10123 15.5471H20.4484L25.5 0Z"
                              :fill="item.active ? '#FFE600' : 'rgba(0,0,0,0.25)'
                                " />
                          </g>
                          <defs>
                            <filter id="filter0_d_104_539" x="0.101257" y="0" width="50.7975" height="48.7029"
                              filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                              <feOffset dy="4" />
                              <feGaussianBlur stdDeviation="2" />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_104_539" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_104_539"
                                result="shape" />
                            </filter>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div class="col-span-6">
                      <div class="aspect-auto">
                        <nuxt-img :class="item.active
                          ? 'w-full'
                          : 'blur-sm mix-blend-luminosity'
                          " class="object-cover pb-2 mx-auto pointer-events-none max-h-28 min-h-28" width="93"
                          height="121" loading="lazy" format="webp" :alt="item.alt" :src="item.productImage"></nuxt-img>
                      </div>
                    </div>
                    <div class="grid items-end justify-end col-span-3">
                      <div class="grid text-right">
                        <span class="relative text-lg line-through top-1" :class="item.active ? '' : 'blur-sm '">
                          ${{ item.discountedPrice }}
                        </span>
                        <span class="text-2xl font-bold" :class="!item.active ? 'blur-sm' : 'text-greenActive2'
                          ">
                          FREE
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full mt-8 sm-max:pb-24 md:mt-0 md:px-4">
          <div class="flex flex-col items-center gap-x-6 md:flex-row">
            <button v-if="getActiveLevel()" @click="submitRewards"
              class="max-w-sm !text-2xl md:ml-0 lg:max-w-lg btn--special lg:!text-3xl">
              UPGRADE MY ORDER!
            </button>
            <button v-else class="!text-lg md:ml-4 btn--special md:!text-xl" @click="cancelRewards">
              No thanks, I’ll pass on this one-time offer
            </button>

            <a v-if="getActiveLevel()" href="javascript:void(0)" @click="cancelRewards"
              class="block text-lg font-semibold leading-none text-center text-gray-800 underline border-b border-transparent focus:outline-none"
              data-v-82a0df31="">No thanks, I’ll pass on this one-time offer</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Engine from "~/composables/Engine.js";
const runEngine = new Engine();
const props = defineProps(["state"]);
const { state } = toRefs(props);
const trackEvent = inject("trackEvent");

const upgrades = ref([
  {
    imageSrc: "assets/images/pngkey-2.png",
    alt: "check level",
    discount: "SAVE 58%",
    active: true,
    title: computed(() => {
      const { items, active } = state.value;
      const { items: itemIndex, variants: variantIndex, packs: packIndex } = active;
      const pack = items[itemIndex].Variants[variantIndex].Pack[packIndex];
      return `Add ${pack.PackSize.replace('x', '')} more bags`;
    }),
    productImage: computed(() => {
      const { items, active } = state.value;
      const { items: itemIndex, variants: variantIndex, packs: packIndex } = active;
      const image = items[itemIndex].Variants[variantIndex].Pack[packIndex].Image.url;
      return image;
    }),
    originalPrice: computed(() => {
      const { items, active } = state.value;
      const { items: itemIndex, variants: variantIndex, packs: packIndex } = active;
      const pack = items[itemIndex].Variants[variantIndex].Pack[packIndex]; // for now hardcoded else use strapi
      if (pack.PackSize === 'x3') return 104.85
      if (pack.PackSize === 'x6') return 209.70
    }),
    discountedPrice: computed(() => {
      const { items, active } = state.value;
      const { items: itemIndex, variants: variantIndex, packs: packIndex } = active;
      const pack = items[itemIndex].Variants[variantIndex].Pack[packIndex]; // for now hardcoded else use strapi
      if (pack.PackSize === 'x3') return 47
      if (pack.PackSize === 'x6') return 78.78
    }),
    id: 123456789,
  },
  {
    imageSrc: "assets/images/pngkey-2.png",
    alt: "check level",
    discount: "SAVE $30",
    active: false,
    title: "Signature Bundle",
    quantity: 1,
    productImage: "assets/images/signature-bundle.png",
    originalPrice: 104.85,
    id: 32453656117308,
    discountedPrice: 74.85,
    coupon: "",
  },
  {
    imageSrc: "assets/images/pngkey-2.png",
    alt: "check level",
    discount: "SAVE $30",
    active: false,
    title: "Health booster bundle",
    quantity: 1,
    productImage: "assets/images/image-1234.png",
    originalPrice: 104.85,
    id: 41493466644540,
    discountedPrice: 74.85,
    coupon: "",
  },
]);
const rewards = ref([
  {
    stars: 1,
    alt: "check level",
    active: true,
    title: "Coffee Scoop",
    quantity: 1,
    productImage: "assets/images/unnamed_3.jpg",
    id: 39492736647228,
    coupon: "Y1WWJRZHJYK5",
    discountedPrice: 8.0,
  },
  {
    stars: 2,
    alt: "check level",
    active: false,
    title: "Cold brew Glass",
    productImage: "assets/images/CanGlass_1.png",
    id: 40354395586620,
    quantity: 1,
    coupon: "Y1WWJRZHJYK5",
    discountedPrice: 15.0,
  },
  {
    stars: 3,
    alt: "check level",
    active: false,
    title: "Tumbler",
    id: 39735865114684,
    quantity: 1,
    coupon: "Y1WWJRZHJYK5",
    productImage: "assets/images/NLR_3696_ccexpress.png",
    discountedPrice: 25,
  },
]);
function setActive(selectedItem) {
  selectedItem.active = !selectedItem.active;
  if (selectedItem.active) {
    const nextItem = rewards.value.find((item) => !item.active);
    if (nextItem) {
      nextItem.active = true;
    }
  } else {
    const prevItem = rewards.value.reverse().find((item) => item.active);
    if (prevItem) {
      prevItem.active = false;
    }
    rewards.value.reverse();
  }
}
function getActiveLevel() {
  return rewards.value.filter((item) => item.active).length;
}
function getSelectedItems() {
  const selectedUpgrades = upgrades.value.filter((item) => item.active);
  const selectedRewards = rewards.value.filter((item) => item.active);
  return [...selectedUpgrades, ...selectedRewards];
}
const checkout = (items) => {
  const item = state.value.items[state.value.active.items];
  const variant = item.Variants[state.value.active.variants];
  const pack = variant.Pack[state.value.active.packs];
  const variantID = variant.variant.VariantID;
  const upgradedPack = variant.Pack.find(
    (packs) => packs.PackSize === `x${parseInt(pack.PackSize.replace('x', '')) * 2}`
  ) || pack


  let checkoutItems = [
    {
      id: variantID,
      quantity: pack.PackSize.replace("x", ""),
      packName: pack.PackName,
      coupon: pack.Coupon,
    },
  ];
  if (items) {
    const doubleOrder = items.find((item) => item.id === 123456789);
    if (doubleOrder) {
      if (upgradedPack) {
        checkoutItems[0] = {
          id: variantID,
          quantity: upgradedPack.PackSize.replace("x", ""),
          packName: upgradedPack.PackName,
          coupon: upgradedPack.Coupon,
        }
      }
      else {
        checkoutItems[0].quantity = parseInt(pack.PackSize.replace('x', '')) * 2;
        checkoutItems[0].coupon = doubleOrder.coupon;
      }

    }
    checkoutItems = [
      ...checkoutItems,
      ...items.filter((item) => item.id !== 123456789),
    ];
  }
  

      
  runEngine.checkoutWithItems(checkoutItems, trackEvent);
};
function submitRewards() {
  const activeLevel = getActiveLevel();
  trackEvent({
        "event": "experiment_event",
        "label": "Upgrade Modal",
        "action": "Upgrade My Order: Level " + activeLevel,
        "value": activeLevel
      });
  const selectedItems = getSelectedItems();
  checkout(selectedItems);
}
function cancelRewards() {
  trackEvent({
        "event": "experiment_event",
        "label": "Upgrade Modal",
        "action": "Deny Upgrade",
      });
  checkout();
}
</script>

<style>
.swiper-wrapper {
  width: 100%;
  height: 100%;
}

.transition-width {
  transition: width 0.5s ease-in-out;
}
</style>
